import { vuexTypes } from '../types'
import { usersService } from '@api/users.service'

function getInitialState () {
  return {
    listCorporateUsers: []
  }
}

export const state = getInitialState()

export const mutations = {
  SET_LOGGED_OUT_STATE (state) {
    Object.assign(state, getInitialState())
  },
  SET_LIST_CORPORATE_USERS (state, list) {
    state.listCorporateUsers = list
  }
}

export const actions = {
  async GET_LIST_CORPORATE_USERS ({ commit }, filter) {
    const listCorporateUsers = await usersService.loadСorporateUsers(filter)
    if (listCorporateUsers._parsedData.data) {
      commit(vuexTypes.SET_LIST_CORPORATE_USERS, listCorporateUsers._parsedData.data)
    } else {
      commit(vuexTypes.SET_LIST_CORPORATE_USERS, [])
    }
  }
}

export const getters = {
  getCorporateUsers: state => state.listCorporateUsers
}

export default {
  actions,
  getters,
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/vuex/modules/users.module.js